<template>
    <section>
        <div>
            <div v-for="modulo in modulos" :key="modulo.idChecklistModulo">
                <component v-for="(componente, identificador) in modulo.componentes" :key="identificador" :is="componente.chave"
                    v-bind="componente" :etapaComponente="componente.etapa" :localRealizacao="modulo.localRealizacao" :resumoModulos="true"
                    :modulo="modulo.idChecklistModulo" :resumo="true" />
            </div>
        </div>
    </section>
</template>


<script>
import { defineComponent } from 'vue'
import Icone from '@/components/Icone.vue'
import Formulario from '@/common/Formulario.vue'
import Foto from '@/common/foto/Foto.vue'
import Avaria from '@/common/avaria/Avaria.vue'
import EstadoPneu from '@/common/EstadoPneu.vue'
import Acessorio from '@/common/acessoriosEquipamentos/Acessorio.vue'
import Combustivel from '@/common/combustivel/Combustivel.vue'
import Texto from '@/common/Texto.vue'
import TextoGrande from '@/common/TextoGrande.vue'
import OpcaoUnica from '@/common/OpcaoUnica.vue'

/* eslint-disable vue/no-unused-components */
export default defineComponent({
    name: 'ResumoModulos',
    components: {
		Icone,
		Formulario,
		Foto,
		Avaria,
		EstadoPneu,
		Acessorio,
		Combustivel,
		Texto,
		TextoGrande,
		OpcaoUnica,
	},
    props: {
        modulos: {
            type: Object,
            required: true
        }
    }
})
</script>